import { render, staticRenderFns } from "./CreateAdministratorForm.vue?vue&type=template&id=14d4042e&scoped=true&"
import script from "./CreateAdministratorForm.vue?vue&type=script&lang=js&"
export * from "./CreateAdministratorForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateAdministratorForm.vue?vue&type=style&index=0&id=14d4042e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d4042e",
  null
  
)

export default component.exports